import { UserForm } from "components/forms/UserForm"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate, useSearchParams } from "react-router-dom"
import { getTintVTOService } from "services/tintvto"
import { IntegrationType, UserData } from "types"
import { BaseHeaderLayout, Box, ContentLayout, Link } from "@strapi/design-system"
import { ArrowLeft } from "@strapi/icons"
import { useAlert } from "providers/AlertProvider"

interface UserPageProps {
  add?: boolean
}

export const UserPage = ({ add }: UserPageProps) => {
  const { showAlert } = useAlert()
  const { t } = useTranslation()
  const service = getTintVTOService()
  const [searchParams] = useSearchParams()
  const username = searchParams.get("username")
  const group = searchParams.get("group")

  const [loading, setLoading] = useState(false)
  const [userData, setUserData] = useState<UserData>({
    username: "",
    password: "",
    group: null,
    merchantId: "",
    integrationType: IntegrationType.COMMON,
  })
  const navigate = useNavigate()

  useEffect(() => {
    if (add)
      setUserData({
        password: "",
        username: "",
        group: null,
        merchantId: "",
        integrationType: IntegrationType.COMMON,
      })
    else if (!add && username && group)
      setUserData({
        password: "",
        username: username,
        group: group,
        merchantId: "",
        integrationType: IntegrationType.COMMON,
      })
  }, [add, username, group])

  const handleSave = async () => {
    setLoading(true)
    let error
    try {
      if (add) {
        const response = await service.registerUser(userData)
        error = response.errors ? response.errors[0] : false
        showAlert({
          error: !!error,
          text: error ? error.message : t("userPage.created", { username: userData.username }),
        })
      } else {
        const response = await service.updateUser(userData)

        error = response.errors ? response.errors[0] : false

        showAlert({
          error: !!error,
          text: error ? error.message : t("userPage.updated", { username: userData.username }),
        })
      }
    } catch (err) {
      error = JSON.parse(JSON.stringify(err))?.graphQLErrors[0]
      showAlert({
        error: !!error,
        text: error ? error.message : t("userPage.updated", { username: userData.username }),
      })
    }

    setLoading(false)

    if (!error) navigate(`/users`)
  }

  return (
    <Box>
      <BaseHeaderLayout
        title={t("userPage.addUser")}
        as={"h1"}
        navigationAction={
          <Link startIcon={<ArrowLeft />} to={`/users`}>
            {t("userPage.backToUsers")}
          </Link>
        }
      />

      <ContentLayout>
        <UserForm
          showGroups={true}
          showMerchantId={false}
          userData={userData}
          add={add}
          onChange={(data) => setUserData(data)}
          loading={loading}
          handleSave={handleSave}
        />
      </ContentLayout>
    </Box>
  )
}
